import { render, staticRenderFns } from "./OtherIncomeTable.vue?vue&type=template&id=3a8bcc50&scoped=true"
import script from "./OtherIncomeTable.vue?vue&type=script&lang=js"
export * from "./OtherIncomeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8bcc50",
  null
  
)

export default component.exports